import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-datepicker/dist/react-datepicker.css';

// Global styles to ensure navbar stays fixed
const globalStyles = `
  body {
    padding-top: 70px !important;
  }
`;

// Inject global styles
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.type = 'text/css';
  styleSheet.innerText = globalStyles;
  document.head.appendChild(styleSheet);
}

import Navbar from './components/Navbar.jsx';
import Login from './pages/login/login.jsx';
import Dashboard from './pages/dashboard/Dashboard';
import ApplicantsList from './pages/applicants/ApplicantsList.jsx';
import ApplicantForm from './pages/applicants/ApplicantForm.jsx';
import BulkUpload from './pages/bulk/BulkUpload.jsx';
import RejectUpload from './pages/rejectUpload/RejectUpload.jsx';
import Reports from './pages/reports/Reports.jsx';
import Notifications from './pages/notification/Notifications.jsx';


function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));

  useEffect(() => {
    const checkToken = () => {
      const current = localStorage.getItem('token');
      if (current !== token) setToken(current);
    };
    const interval = setInterval(checkToken, 1000);
    return () => clearInterval(interval);
  }, [token]);

  useEffect(() => {
    document.body.style.paddingTop = token ? '70px' : '0';
    return () => { document.body.style.paddingTop = '0'; };
  }, [token]);

  const PrivateRoute = ({ children }) => {
    return token ? children : <Navigate to="/login" replace />;
  };

  return (
    <Router>
      <div className="App" style={{ minHeight: '100vh' }}>
        <Routes>
          <Route path="/login" element={ token ? <Navigate to="/dashboard" replace /> : <Login /> } />
          <Route path="/" element={<Navigate to={ token ? '/dashboard' : '/login' } replace />} />

          <Route path="/dashboard" element={
            <PrivateRoute>
              <>
                <Navbar />
                <div className="container-fluid pt-2"><Dashboard /></div>
              </>
            </PrivateRoute>
          } />
          <Route path="/applicants" element={
            <PrivateRoute>
              <>
                <Navbar />
                <div className="container-fluid pt-2"><ApplicantsList /></div>
              </>
            </PrivateRoute>
          } />
          <Route path="/applicants/new" element={
            <PrivateRoute>
              <>
                <Navbar />
                <div className="container-fluid pt-2"><ApplicantForm /></div>
              </>
            </PrivateRoute>
          } />
          <Route path="/applicants/:atsNumber/edit" element={
            <PrivateRoute>
              <>
                <Navbar />
                <div className="container-fluid pt-2"><ApplicantForm /></div>
              </>
            </PrivateRoute>
          } />
          <Route path="/bulk-upload" element={
            <PrivateRoute>
              <>
                <Navbar />
                <div className="container-fluid pt-2"><BulkUpload /></div>
              </>
            </PrivateRoute>
          } />
          <Route path="/reports" element={
            <PrivateRoute>
              <>
                <Navbar />
                <div className="container-fluid pt-2"><Reports /></div>
              </>
            </PrivateRoute>
          } />
          <Route path="/notifications" element={
            <PrivateRoute>
              <>
                <Navbar />
                <div className="container-fluid pt-2"><Notifications /></div>
              </>
            </PrivateRoute>
          } />
          <Route path="/reject-upload" element={
            <PrivateRoute>
              <>
                <Navbar />
                <div className="container-fluid pt-2"><RejectUpload /></div>
              </>
            </PrivateRoute>
          } />
          <Route path="*" element={<Navigate to={ token ? '/dashboard' : '/login' } replace />} />
        </Routes>
        <ToastContainer position="top-right" autoClose={3000} />
      </div>
    </Router>
  );
}

export default App;